import * as React from 'react';

type SvgInstagramProps = React.SVGProps<SVGSVGElement>;

const SvgInstagram = (props: SvgInstagramProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="37"
    fill="none"
    viewBox="0 0 38 37"
  >
    <rect width="37" height="37" x="0.5" fill="#fff" fillOpacity="0.1" rx="4.933"></rect>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M13.246 7.554a5.19 5.19 0 0 0-5.192 5.191v11.617a5.19 5.19 0 0 0 5.192 5.191h11.616a5.19 5.19 0 0 0 5.192-5.191V12.745a5.19 5.19 0 0 0-5.192-5.191zM6.82 12.745a6.425 6.425 0 0 1 6.425-6.425h11.616a6.425 6.425 0 0 1 6.425 6.425v11.617a6.425 6.425 0 0 1-6.425 6.424H13.246a6.425 6.425 0 0 1-6.425-6.424zm12.878 1.77a4.03 4.03 0 1 0-1.183 7.973 4.03 4.03 0 0 0 1.183-7.973m-3.016-.685a5.263 5.263 0 1 1 4.849 9.342 5.263 5.263 0 0 1-4.849-9.342m8.762-2.283a.617.617 0 1 0 0 1.233h.014a.617.617 0 1 0 0-1.233z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default SvgInstagram;
